import React from "react";
import S from "./Text.styled";
import { MainInner, MainSection, motionAnimation } from "@/styles/global";
import { DisplayHeadingS } from "@/styles/typography";
import { ColorOptions, IWPImage, IWPLink, IWPTitleParts } from "@/src/types";
import { TextButton, BackgroundImage, Wysiwyg } from "@/styles/components";
import { isLight } from "@/src/helpers";
import TitleParts from "@/components/global-components/TitleParts";
import { motion } from "framer-motion";

export interface TextProps {
  blockId: string;
  background: string;
  backgroundColor: ColorOptions;
  backgroundImage: IWPImage;
  backgroundType: "card" | "fill";
  textColor: "creme" | "black";
  titleParts: IWPTitleParts;
  title: string;
  text: string;
  link: IWPLink;
  alignText?: "left" | "right";
}

const Text: React.FC<TextProps> = ({
  blockId = "",
  background,
  backgroundColor,
  backgroundType,
  backgroundImage,
  textColor,
  titleParts,
  title,
  text,
  link,
  alignText,
}) => {
  const alignContentLeft = alignText === "left";
  const color =
    background === "color"
      ? backgroundColor === "yellow"
        ? "brown"
        : isLight(backgroundColor)
          ? "black"
          : "creme"
      : textColor;

  backgroundType = backgroundType || "fill";

  return (
    <S.Section as={motion.section} id={blockId} {...motionAnimation}>
      <S.Wrapper
        $background={background === "color" ? backgroundColor : undefined}
        $backgroundType={backgroundType}
      >
        {background === "image" && (
          <BackgroundImage
            image={backgroundImage}
            reverseOverlay={!alignContentLeft}
          />
        )}
        <MainInner>
          <S.TextContainer
            $alignLeft={alignContentLeft}
            $background={background === "color" ? backgroundColor : undefined}
            $backgroundType={backgroundType}
          >
            <S.TextWrapper>
              {titleParts ? (
                <DisplayHeadingS>
                  <TitleParts
                    titleParts={titleParts}
                    backgroundColor={backgroundColor}
                  />
                </DisplayHeadingS>
              ) : (
                <DisplayHeadingS color={color}>
                  {title && title}
                </DisplayHeadingS>
              )}

              {text && <Wysiwyg html={text} color={color} size={18} />}
              {link && <TextButton wpLink={link} />}
            </S.TextWrapper>
          </S.TextContainer>
        </MainInner>
      </S.Wrapper>
    </S.Section>
  );
};

export default Text;
